import {
  useCapacityManagementRoot,
  type OptionalCapacityManagementRootRequest,
} from 'src/apis/capacity-management/use-capacity-management-root';
import {
  useOptionalReshuffleServiceRoot,
  type OptionalReshuffleServiceRootRequest,
} from 'src/apis/reshuffle-service/use-reshuffle-service';
import type { TransportTabAvailability } from 'src/pages/company-transactions/transport/tabs';

export function useTransportTabAvailability():
  | { loaded: false }
  | { loaded: true; value: TransportTabAvailability } {
  const capacityManagementRoot = useCapacityManagementRoot();
  const reshuffleServiceRoot = useOptionalReshuffleServiceRoot();

  const reshuffleRootLoaded =
    reshuffleServiceRoot === undefined || reshuffleServiceRoot.loaded;

  if (!capacityManagementRoot.response || !reshuffleRootLoaded)
    return { loaded: false };

  return {
    loaded: true,
    value: getTransportTabAvailability(
      capacityManagementRoot,
      reshuffleServiceRoot
    ),
  };
}

export function getTransportTabAvailability(
  capacityManagementRoot: OptionalCapacityManagementRootRequest,
  reshuffleServiceRoot: OptionalReshuffleServiceRootRequest
): TransportTabAvailability {
  return {
    hasMultiYearTransactions: Boolean(
      capacityManagementRoot.response?.data._links
        ?.multiYearTransactionTransportAllocation?.href
    ),
    hasReshuffleTransactions: Boolean(
      reshuffleServiceRoot?.response?.data._links?.searchAllocations
    ),
  };
}
